
import {useState} from 'react';
const content = [
    {
    id: "opico",
    title:"Opico Limited",
    dates:"from April 2022 to present",
    desc: "Opico is the UK’s largest independent distributor of agricultural machinery with over five decades of experience and knowledge of the trade.",
    link: "https://www.opico.co.uk",
    duties: [
        "Updating the Intranet system with new features built using PHP, JavaScript, HTML5 and CSS3 and various libraries such as D3, jQuery, mysqli, mysqlsrv.",
        "Creating and updating database tables manually or through the intranet system using PHP, MySQL and SQL.",
        "Converting the intranet system to use more modern practices and making it more mobile compatible.", 
        "Writing and updating batch scripts to run windows tasks and to integrate with various accounting software such as Sage1000.",
        "Integrating the intranet system with APIs such as DHL and DPD.",
        "Setting up laptops, mobile phones and tablets for new dealers and new starters.",
        "Joining devices to the Domain, setting up and managing users on Active Directory Domain Controller (ADDCO), installing antivirus software and setting up different email accounts, installing printer drivers and setting them up.",
        "Managing the mail server and spam filters.",
        "Booting up AWS EC2 servers and creating AMI’s. ",
        "CI/DC pipelines with AWS Code Commit and Code Deploy.",
    "Checking and setting up CloudWatch logs and creating AWS Cloud Front end points.",
    "Getting familiar with AWS Route53, VPC, Load balancers, Bluegreen deployments, auto scaling, S3 buckets, EFS, AWS backup and RDS.",
    "Working with Linux systems in particular centos7 and amazon Linux2.",
    "Figma for UI and feature prototyping.", 

    ]
    },
    {
    id: "TTR",
    title:"TTR",
    dates:"from Sept 2019 to Nov 2021",
    desc: "The training room is an online plateform that offers sophisticated training and certification on different subject areas.",
    link: "https://www.thetrainingroom.com/",
    duties: [
        "Learned the fundermentals of software development.",
        "Learned Html5, css3, and javascript for frontend web developement.",
        "Learned Nodejs for backend development.",
        "Leaned SQL for databse querying and data storage.",
        "I also learned java which is a powerfull tool for android development and can also be used for backend development."
    ]
    },

]


const Experience = () => {

    const [divContent, setDivContent] = useState({
        title: content[0].title,
        desc: content[0].desc,
        link:content[0].link,
        dates: content[0].dates,
        duties: content[0].duties
    });


    const handleClick = (e) => {
    const id =  e.target.id;
    content.map((item) => {
        if(item.id === id){
           setDivContent({
               desc: item.desc,
               link: item.link,
               title: item.title,
               dates: item.dates,
               duties: item.duties
            });
        }
        return item.id;
    });


    };

    return (
        <section id="experience" className=" h-screen w-full my-8 p-4 overflow-hidden sm-max:p-1 lg-min:p-1 ">
        <div className="relative w-full h-full py-4 overflow-hidden sm-max:py-2 lg-min:py-2">

            <h1 className="flex items-center justify-center w-40 h-10 my-2 p-2 text-2xl text-white rounded-2xl bg-gradient-to-br from-customyellow to-customdarkblue lg-min:">Experience</h1>

            <ul id="experience-ul" className="list-none flex items-center mb-4 h-20 p-2 bg-gradient-to-br from-customyellow to-customdarkblue rounded-2xl overflow-hidden sm-max:grid sm-max:grid-cols-1 sm-max:overflow-y-scroll lg-min:mb-2 ">
                {content.map((item) => <li id={item.id} key={item.id} onClick={handleClick} className=" relative flex items-center bg-transparent text-white text-lg cursor-pointer w-60 m-1 p-1 sm-max:w-full sm-max:text-base ">{item.title}</li>)}
            </ul>

        
            <div className=" relative h-4/6 w-full sm-max:h-4/6 ">
            
                <div id="blur" className="absolute -inset-0.5 w-full h-full bg-gradient-to-br from-customyellow to-customdarkblue filter blur-xl opacity-75"></div>

                <div id="experience-desc" className="relative flex items-center h-full w-full justify-center bg-gradient-to-br from-customyellow to-customdarkblue overflow-hidden sm-max:overflow-y-scroll lg-min:overflow-y-scroll ">

                    <div className=" group w-full h-full border-l-2 border-white ml-8 p-2 text-white sm-max:p-1 lg-min:p-1">
                    <h2 className=" text-2xl p-1  group-hover:text-customdarkblue ">{divContent.title} <a href={divContent.link} target="_blank" rel="noopener noreferrer"><i className="fas fa-external-link-alt"></i></a></h2>

                    <p className=" p-1  sm-max:text-sm lg-min:text-base ">{divContent.desc}</p>

                    <ul className=" list-none  p-1 ">
                        {divContent.duties.map((item, index)=> <li key={Date.now() + index}  className=" p-1 sm-max:text-sm lg-min:text-base "><i className="fas fa-caret-right mr-2 group-hover:text-customdarkblue "></i>{item}</li>)}
                    </ul>
                    </div>
                </div> 

            </div>
        </div>
        </section>
    );
};


export default Experience;